import script from "./reserveList.vue?vue&type=script&setup=true&lang=js"
export * from "./reserveList.vue?vue&type=script&setup=true&lang=js"

import "./reserveList.vue?vue&type=style&index=0&id=33dfcc4c&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dfcc4c"]])

export default __exports__